import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HugeiconsIconComponent } from '@hugeicons/angular';
import { InboxIcon } from '@hugeicons/core-free-icons';

@Component({
    selector: 'app-empty-state',
    standalone: true,
    imports: [CommonModule, HugeiconsIconComponent],
    templateUrl: './empty-state.component.html',
    styleUrl: './empty-state.component.scss'
})
export class EmptyStateComponent {
    @Input() icon: any = InboxIcon;
    @Input() title: string = 'No Data';
    @Input() description: string = 'No data available at this stage.';
    @Input() iconSize: number = 48;
}
